import React from 'react';
import { makeStyles } from "@material-ui/core";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

const useStyles = makeStyles((theme) => ({
    cardBlock: {
        marginBottom: 20,
        backgroundColor: '#fff',
        borderRadius: 4,
        '@media (min-width: 1025px)': {
            marginBottom: 0,
        },
    },
    cardMainHeading: {
        fontWeight: 'bold',
        margin: 0,
        padding: '20px 15px 8px',
        fontSize: 15
    },
    totalTestDesc: {
        padding: '0 15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    desc: {
        color: '#8E9598',
        fontSize: 13,
        flex: 1
    },
    startTest: {
        color: '#008E76',
        fontSize: 13,
        marginRight: 5
    },
    syllabusContainer: {
        backgroundColor: '#E4F5F0E8',
        padding: '7px 15px',
        marginTop: 15,
        '& span': {
            color: '#008E76',
            fontSize: 12
        }
    },
    startBtn: {
        display: 'flex',
        alignItems: 'center',
        cursor: "pointer",
        '& span': {
            color: '#008E76',
            fontSize: 12,
            fontWeight: 'bold'
        },
        '& svg': {
            fill: '#008E76',
        }
    }
}));
const ExamSeriesCard = props => {
    const classes = useStyles();

    return (
        <>
          <div className={classes.cardBlock}>
                <h4 className={classes.cardMainHeading}>SSC JE Tier I - Mock Test</h4>
                <div className={classes.totalTestDesc}>
                    <span className={classes.desc}>100 Qtns.120 mins.100 Marks</span>
                    <div className={classes.startBtn}>
                        <span className={classes.startTest}>Start Test</span>
                        <ArrowRightAltIcon />
                    </div>
                </div>
                <div className={classes.syllabusContainer}>
                    <span>Syllabus : English, Hindi</span>
                </div>
          </div>
        </>
    );
};
export default ExamSeriesCard;